import React from 'react'
import { useMedia } from 'sb-hooks'
import { scrollToElement } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Button from 'components/_new/Button/Button'
import Text from 'components/_new/typography/Text/Text'
import { WidthContainer } from 'components/_new/layout/widthContainer'

import messages from './messages'
import s from './Hero.scss'


const handleButtonClick = () => {
  scrollToElement('selectGender', true)
}

const GiftPageHero = () => {
  const { isMobile } = useMedia()

  return (
    <div className={s.container}>
      <WidthContainer>
        <Box className={s.content} alignCenter center>
          <Text className={s.title} message={messages.title} color="white" size="32-40" semibold uppercase />
          <Box className={s.subTitleContainer} mt="24" center>
            <Text message={messages.subTitle} color="white" size={isMobile ? '18-24' : '32-40'} semibold />
          </Box>
          <Box mt="24">
            <Button
              className={s.button}
              title={messages.buttonTitle}
              size="md"
              color="brand"
              id="buyGiftNow"
              rightIcon={!isMobile && 'rightArrowSmall'}
              uppercase
              fullWidthOnMobile
              onClick={handleButtonClick}
            />
          </Box>
        </Box>
      </WidthContainer>
    </div>
  )
}


export default GiftPageHero
